require('lg-video/dist/lg-video')
import lightGallery from 'lightgallery';

$('.video-reference-preview').lightGallery({
  counter: false,
  download: false,
  selector: '.video-reference-preview__image',
  youtubePlayerParams: {
    rel: 0,
    getCaptionFromTitleOrAlt: false,
  }
});

